import {startLoading, setData, setArchiveData, startLoadingFullData, setFullData} from "./cnASlice";
import axios from "axios";
import {zynity_api} from "../../../../../config/external-routes";

export const updateCnAData = (data:any, user_id:any, tool:any) => {
    return async (dispatch: (arg0: { payload: any; type: string; }) => void, state: any) => {
        const cna_data = state().tool_cna;
        console.log("sTATE", cna_data, data, user_id, tool)

        let index_user_data = cna_data.data.findIndex((item: { user_id: any; }) => item.user_id == user_id)
        if (index_user_data === -1) {
            return false
        }

        /*let index_tool_data = cna_data.data[index_user_data][tool.toLowerCase()];
        let updated_data = cna_data.data[index_user_data][tool.toLowerCase()]*/

        // Create a deep copy of the state object and its nested properties.
        const updatedDataArray = {
            ...cna_data,
            data: cna_data.data.map((item: any, index: number) => {
                if (index === index_user_data) {
                    // Update the tool-specific data for the user.
                    return {
                        ...item,
                        [tool.toLowerCase()]: data,
                    };
                }
                return item;
            }),
        };

        dispatch( setData(updatedDataArray.data) )
    }
}

export const getCnAData = ({organization_id, team_id}: any) => {
    return async (dispatch: (arg0: { payload: any; type: string; }) => void, state: any) => {
        dispatch(startLoading())
        dispatch(startLoadingFullData())

        //Get Archive Data
        const user = state().auth
        const pastDate = state().tool_cna.pastDate;
        axios.defaults.headers.common = {'Authorization': `Bearer ${user.access_token}`}

        //Get Active Data
        console.log("getting 1")
        axios.get(zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id) + '/tools/CnA?pastDate=' + pastDate)
            .then((response) => {
                console.log("result 1")
                dispatch( setData(response.data) )
            }).catch((err) => {
            console.log('Error get cna Data 1', err);
        })

        console.log("getting 1")
        axios.get(zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id) + '/tools/CnA?pastDate=' + pastDate + '&full_data=true')
            .then((response) => {
                console.log("result 1")
                dispatch( setFullData(response.data) )
            }).catch((err) => {
            console.log('Error get cna Data 2', err);
        })

        console.log("getting 1")
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id) + '/tools/CnA?pastDate=' + pastDate;
        axios.get(`${url}&content_status=Archive&full_data=true`)
            .then((response) => {
                console.log("result 1")
                dispatch( setArchiveData(response.data) )
            }).catch((err) => {
            console.log('Error get cna Archive Data 3', err);
        })
    }
}
